import { render, staticRenderFns } from "./secretKey.vue?vue&type=template&id=196874c4&scoped=true"
import script from "./secretKey.vue?vue&type=script&lang=js"
export * from "./secretKey.vue?vue&type=script&lang=js"
import style0 from "./secretKey.vue?vue&type=style&index=0&id=196874c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196874c4",
  null
  
)

export default component.exports